<template>
  <Card>
    <LocalDataTable :columns="columns" :order-column="0" :order-type="1" :ajax-link="ajaxLink"></LocalDataTable>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import LocalDataTable from "@/components/LocalDataTable";
export default {
name: "MarketRequestManage",
  components: {LocalDataTable, Card},
  data()
  {
    return{
      columns:[
          {title : 'شماره'},
          {title : 'درخواست دهنده'},
          {title : 'تاریخ'},
          {title : 'محصول'},
          {title : 'ویژگی'},
          {title : 'وضعیت'},
          {title : 'تعداد پیشنهاد'},
          {title : '<i class="far fa-cogs"></i>'},
          ],
      ajaxLink :'admin/MarketRequest/List'
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('درخواست های بازار');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>